// CORE-1447 — с чего начинать автозапуск знакомства.
//
// До этой задачи вопроса не было: автозапуск случался ровно один раз в жизни,
// до первого старта, и начинать было неоткуда, кроме первого шага. Теперь
// сервер возвращает и тур, который человек закрыл на половине и с тех пор
// прошло три дня, — а ему Агапелла на прощание сказала: «Я запомнила, где мы
// остановились. Вернуться к знакомству можно в любой момент». Начать такой тур
// с первого шага значит эту фразу опровергнуть.
//
// CORE-1750 — то же для тура, брошенного посреди: сервер теперь возвращает и
// его, и продолжать его нужно с того же шага.
//
// Решение отдельной функцией, потому что провайдер — большой компонент с
// таймерами и маршрутами, а здесь всего три ветки, и их видно целиком.
import { OnboardingTourDto } from '../types/onboardingTour';

export type AutoLaunchTarget =
    | { kind: 'start' }
    | { kind: 'resume'; step: number };

/**
 * С какого шага открывать тур, или `null` — не открывать вовсе.
 *
 * Разрешение на автозапуск принимает сервер (`shouldAutoLaunch`); здесь только
 * выбор точки входа.
 */
export function autoLaunchTarget(state: OnboardingTourDto): AutoLaunchTarget | null {
    if (!state.shouldAutoLaunch) return null;

    // Возвращаем на сохранённый шаг только отложенный тур: закрытый крестиком
    // или брошенный посреди. У остальных состояний сохранённого шага либо нет,
    // либо он уже не про «продолжить»: завершённый и пропущенный сюда не
    // попадают вовсе, а «не начинал» — это первый шаг по определению.
    //
    // CORE-1750 — брошенный тур (закрыл вкладку на третьем шаге и не вернулся)
    // приходит сюда как 'in_progress': сервер разрешает его автозапуск через
    // три дня без активности. Начать его с первого шага значило бы снова
    // показывать то, что человек уже видел, — и `/start` вдобавок записал бы
    // это как новый запуск.
    if (state.status !== 'closed' && state.status !== 'in_progress') return { kind: 'start' };

    const step = state.currentStep;
    // Шаг вне диапазона — данные из другой версии тура или из будущего; в этом
    // случае честнее начать сначала, чем открыть подсветку в пустоту.
    if (!Number.isInteger(step) || step <= 1 || step > state.totalSteps) {
        return { kind: 'start' };
    }
    return { kind: 'resume', step };
}
